module.exports = __webpack_public_path__ + "img/logo.93ba8420.svg";